import { message } from "antd"
import axios from "axios"
import { create } from "zustand"

export const useModels = create((set, get) => ({
    models: [],
    ed: {},
    setEd: (v) => {
        set({ ed: v })
    },
    columns: [
        {
            title: 'Nomi',
            dataIndex: 'nameuz',
            key: 'nameuz',
        },
        {
            title: 'Nomi',
            dataIndex: 'nameru',
            key: 'nameru',
        },
        {
            title: "Brand",
            dataIndex: 'brand_name',
            key: 'brand_name',
        }
    ],
    getModels: () => {
        axios.get('/models').then(res => {
            set({ models: res.data })
        }).catch(error => {
            message.error("Ma'lumotlarni olishda muammo yuzaga keldi!!!")
        })
    },
    deleteModel: (id) => {
        axios.delete('/models/' + id).then(res => {
            get().getModels()
            message.success("Muvaffaqiyatli o'chirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'chirishda muammo yuzaga keldi!!!")
        })
    },
    createModel: (v) => {
        axios.post('/models', v).then(res => {
            get().getModels()
            message.success("Muvaffaqiyatli qo'shildingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni qo'shishda muammo yuzaga keldi!!!")
        })
    },
    updateModel: (v) => {
        axios.put('/models/' + v.id, v).then(res => {
            get().getModels()
            message.success("Muvaffaqiyatli o'zgartirdingiz!")
        }).catch(error => {
            message.error("Ma'lumotlarni o'zgartirishda muammo yuzaga keldi!!!")
        })
    },
}))